// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-Table-Cells-CellText-___CellText-module__input {
  width: 100%;
  height: 100%;
  border: none;
  padding: 7px 5px;
  text-align: center;
  text-overflow: ellipsis;
  outline: none;
  position: relative;
  z-index: 1;
}

.app-components-Table-Cells-CellText-___CellText-module__input[type='number']::-webkit-outer-spin-button,
.app-components-Table-Cells-CellText-___CellText-module__input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.app-components-Table-Cells-CellText-___CellText-module__input[type='number'] {
  -moz-appearance: textfield;
}

.app-components-Table-Cells-CellText-___CellText-module__input::-webkit-calendar-picker-indicator {
  margin-left: 0px;
}

.app-components-Table-Cells-CellText-___CellText-module__read {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: pre-wrap;
  text-align: center;
  position: relative;
  z-index: 1;
  overflow: hidden;
}

.app-components-Table-Cells-CellText-___CellText-module__error {
  border: solid 2px red;
  outline-color: red;
}

.app-components-Table-Cells-CellText-___CellText-module__errorTooltip {
  background-color: #fff;
  padding: 5px;
  margin-top: 10px;
  border: solid 1px #ccc;
  color: red;
  box-shadow: 1px 2px 2px #ccc;
}

.app-components-Table-Cells-CellText-___CellText-module__triangle {
  width: 10px;
  height: 10px;
  transform: rotateZ(45deg);
  border-left: solid 1px #ccc;
  border-top: solid 1px #ccc;
  position: absolute;
  top: 5px;
  left: 20px;
  z-index: 3;
  background-color: #fff;
}

.app-components-Table-Cells-CellText-___CellText-module__renderRead {
  max-width: 100%;
  white-space: pre-wrap;
  padding: 5px;
  text-align: center;
  overflow-y: auto;
  overflow-x: hidden;
}

.app-components-Table-Cells-CellText-___CellText-module__renderRead .app-components-Table-Cells-CellText-___CellText-module__linkButton {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 200ms;
    font-size: 15px;
    color: #0066cc;
  }

.app-components-Table-Cells-CellText-___CellText-module__renderRead:hover .app-components-Table-Cells-CellText-___CellText-module__linkButton {
      opacity: 1;
    }

.app-components-Table-Cells-CellText-___CellText-module__reduced {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 28px;
}

.app-components-Table-Cells-CellText-___CellText-module__url {
  width: 100%;
  height: 100%;
  color: #0066cc;
}
`, "",{"version":3,"sources":["webpack://./app/components/Table/Cells/CellText/CellText.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AAoBpB;;AAlBE;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,yBAAyB;IACzB,eAAe;IACf,cAAc;EAChB;;AAGE;MACE,UAAU;IACZ;;AAIJ;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB","sourcesContent":[".input {\n  width: 100%;\n  height: 100%;\n  border: none;\n  padding: 7px 5px;\n  text-align: center;\n  text-overflow: ellipsis;\n  outline: none;\n  position: relative;\n  z-index: 1;\n}\n\n.input[type='number']::-webkit-outer-spin-button,\n.input[type='number']::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.input[type='number'] {\n  -moz-appearance: textfield;\n}\n\n.input::-webkit-calendar-picker-indicator {\n  margin-left: 0px;\n}\n\n.read {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  white-space: pre-wrap;\n  text-align: center;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n}\n\n.error {\n  border: solid 2px red;\n  outline-color: red;\n}\n\n.errorTooltip {\n  background-color: #fff;\n  padding: 5px;\n  margin-top: 10px;\n  border: solid 1px #ccc;\n  color: red;\n  box-shadow: 1px 2px 2px #ccc;\n}\n\n.triangle {\n  width: 10px;\n  height: 10px;\n  transform: rotateZ(45deg);\n  border-left: solid 1px #ccc;\n  border-top: solid 1px #ccc;\n  position: absolute;\n  top: 5px;\n  left: 20px;\n  z-index: 3;\n  background-color: #fff;\n}\n\n.renderRead {\n  max-width: 100%;\n  white-space: pre-wrap;\n  padding: 5px;\n  text-align: center;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  .linkButton {\n    position: absolute;\n    top: 0;\n    right: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    opacity: 0;\n    transition: opacity 200ms;\n    font-size: 15px;\n    color: #0066cc;\n  }\n\n  &:hover {\n    .linkButton {\n      opacity: 1;\n    }\n  }\n}\n\n.reduced {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  min-height: 28px;\n}\n\n.url {\n  width: 100%;\n  height: 100%;\n  color: #0066cc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `app-components-Table-Cells-CellText-___CellText-module__input`,
	"read": `app-components-Table-Cells-CellText-___CellText-module__read`,
	"error": `app-components-Table-Cells-CellText-___CellText-module__error`,
	"errorTooltip": `app-components-Table-Cells-CellText-___CellText-module__errorTooltip`,
	"triangle": `app-components-Table-Cells-CellText-___CellText-module__triangle`,
	"renderRead": `app-components-Table-Cells-CellText-___CellText-module__renderRead`,
	"linkButton": `app-components-Table-Cells-CellText-___CellText-module__linkButton`,
	"reduced": `app-components-Table-Cells-CellText-___CellText-module__reduced`,
	"url": `app-components-Table-Cells-CellText-___CellText-module__url`
};
export default ___CSS_LOADER_EXPORT___;
